var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMedal = function SvgIconMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.792 3.747a.999.999 0 0 0-.47-.61l-5.2-3a1 1 0 0 0-1.37.36l-2.34 4.06-2.34-4.06a1 1 0 0 0-1.37-.36l-5.2 3a1 1 0 0 0-.47.61 1 1 0 0 0 .1.75l4 6.83a5.91 5.91 0 0 0-.72 2.66 6 6 0 1 0 11.34-2.72l3.9-6.76a1 1 0 0 0 .14-.76Zm-16.38.62 3.46-2 3.22 5.62a5.94 5.94 0 0 0-3.68 1.58l-3-5.2Zm7 13.62a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm4-8.45a5.9 5.9 0 0 0-1.86-1.15l-.98-1.83 2.42-4.19 3.46 2-3.04 5.17Z",
    fill: "currentColor"
  })));
};
export default SvgIconMedal;